
          import "Input.styles_mhze5j.linaria.css";
          import { styled } from "@linaria/react";
import { css } from "@linaria/core";
import { focusStyle, typeStyle } from "@carvana/showroom-css-theme";
import CheckMark from "../../icons/check-filled-16px.svg";
import ErrorSvg from "../../icons/error-filled-16px.svg";
const labelOffSetWhenFocusedAndPopulated = "-16px";
const iconOffSet = "8px";
export const CheckmarkIcon = /*#__PURE__*/styled(CheckMark)({
  name: "CheckmarkIcon",
  class: "ceh7m7o"
});
export const ErrorIcon = /*#__PURE__*/styled(ErrorSvg)({
  name: "ErrorIcon",
  class: "eubo1it"
});
export const InputWrapper = /*#__PURE__*/styled("div")({
  name: "InputWrapper",
  class: "iyf2hob",
  vars: {
    "iyf2hob-0": [props => props.width ? `${props.width}px` : "100%"]
  }
});
export const InputContainer = /*#__PURE__*/styled("div")({
  name: "InputContainer",
  class: "i1j6fosc"
});
export const FormInput = /*#__PURE__*/styled("input")({
  name: "FormInput",
  class: "fa89gdw"
});
export const inputClass = "i3s7xuf";
export const Label = /*#__PURE__*/styled("label")({
  name: "Label",
  class: "l1gq1r8z"
});
export const CaptionContainer = /*#__PURE__*/styled("div")({
  name: "CaptionContainer",
  class: "cbbfat9"
});
export const DescriptionContainer = /*#__PURE__*/styled("div")({
  name: "DescriptionContainer",
  class: "di0ffsi"
});
export const ErrorMessageContainer = /*#__PURE__*/styled("div")({
  name: "ErrorMessageContainer",
  class: "e1jh9q7h"
});
export const CharacterCountContainer = /*#__PURE__*/styled("div")({
  name: "CharacterCountContainer",
  class: "c1kvimff"
});
export const ClearButton = /*#__PURE__*/styled("button")({
  name: "ClearButton",
  class: "c116c7to"
});
          